import type { ActionState } from "../generated/widget-fixture";
import { key } from "../shared";
import type { Widget, WidgetInput, WidgetState } from "../types";

/** The command or setting a control changes, and the datapoint that reports its state. */
export function controlBindings(widget: Widget, input: WidgetInput) {
  const bindings = widget.bindings ?? [];
  const target = bindings.find((b) => b.command ?? b.setting);
  const report = bindings.find((b) => b.datapoint);
  const targetKey = target?.command ?? target?.setting;
  return {
    target,
    targetKey,
    action: target && targetKey ? input.actions?.[key(target.device, targetKey)] : undefined,
    point: report?.datapoint ? input.points?.[key(report.device, report.datapoint)] : undefined,
    device: input.devices?.[(target ?? report)?.device ?? ""],
  };
}

export function isPending(a: ActionState | undefined) {
  return a?.state === "queued" || a?.state === "delivered";
}

/** Which state a control shows: a lack of permission first, then the delivery, then the device. */
export function controlState(a: ActionState | undefined, hasValue: boolean, offline: boolean): WidgetState {
  if (a && !a.allowed) return "read_only";
  if (isPending(a)) return "pending";
  if (a?.state === "failed" || a?.state === "expired") return "failed";
  if (offline) return "offline";
  return hasValue ? "normal" : "empty";
}
